export const badgeColors = ["primary", "secondary", "tertiary", "dark"] as const;

export const badgeVariants = ["square", "rounded"] as const;

export const badgeSizes = ["small", "large"] as const;

export type BadgeColor = (typeof badgeColors)[number];

export type BadgeVariant = (typeof badgeVariants)[number];

export type BadgeSize = (typeof badgeSizes)[number];
